import ServiceListTable from "@/app/shared/settings/services/list/table";
import { Service } from "@/types";
import { useState, useEffect } from "react";
import ServicePageHeader from "./page-header";
import { fetchServices } from "@/server/api-services";


export default function ServiceListPage() {
    const [service, setService] = useState([] as Service[]);

    useEffect(() => {
        loadServices();
    }, []);

    async function loadServices() {
        const response = await fetchServices();

        

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Service[];

        setService(data);
    }

    const refresh = () => loadServices();

    return (
        <>
            <ServicePageHeader title="Service" hideButton={false} />
            <ServiceListTable
                services={service}
                refresh={refresh}
            />
        </>
    );
}
